/**
 * Videos for the images preview in the details page of the product
 */
const ImagesPreviewVideos = (idParent) => {
    return [];
};
export default ImagesPreviewVideos;
